import React from "react";
import { FormField } from "@modules/formx-react";
import { CustomerTreeSelect, CustomerTreeSelectProps } from "./CustomerTreeSelect";
import { pick } from "@bonliva-crm/common";

type Props = {
  name: string;
  label?: string;
  items: CustomerTreeSelectProps["items"];
};

export function CustomerTreeSelectField(props: Props) {
  return (
    <FormField name={props.name}>
      {(field) => {
        return (
          <CustomerTreeSelect
            expanded
            items={props.items}
            label={props.label}
            transformValue={(x) => {
              return pick(x, "label", "value");
            }}
            {...field.fieldProps}
          />
        );
      }}
    </FormField>
  );
}
